import React from "react";
import DeleteArticlePage from "../Component/DeleteArticlePage";
import { useEffect, useState } from "react";
import { client, getArticle } from "../api.js"

const DeleteArticlePageContainer = () => {
    
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [articleId, setArticleId] = useState(0);

    useEffect(()=> {
        getArticle()
            .then((res)=> {
                setArticles(res);
                setLoading(false);
            })
            .catch((err)=>{
                console.log(err);
            });
    }, [loading]);

    const handleInputChangeId = (id) => {
        setArticleId(id);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        await client.delete(articleId);
        setLoading(true);
    }
    return(
        
        <DeleteArticlePage articles={articles} 
                            articleId={articleId}
                            handleInputChangeId={handleInputChangeId}                    
                            loading={loading}
                            handleSubmit={handleSubmit}/>
    );
}

export default DeleteArticlePageContainer;